\<template>
  <BaseEventAware :ignore="true">
    <modal
      id="missionSuccess"
      name="mission-success"
      class="relative"
      :adaptive="true"
      :click-to-close="false"
      :shift-y="0"
      height="100%"
      @before-open="beforeOpen"
      @before-close="beforeClose"
    >
      <div class="container flex flex-wrap items-center h-full px-4 py-10 mx-auto">
        <div class="flex-none w-full">
          <h3 class="text-5xl font-bold text-center sm:text-6xl">
            <strong class="text-red-500">성공!</strong>
          </h3>
          <!-- eslint-disable -->
          <h2 class="pt-6 text-3xl font-bold text-center sm:text-4xl" v-html="title"></h2>
          <p class="pb-12 mt-1 text-2xl font-bold text-center sm:text-3xl">
            {{ modeText }}
          </p>
        </div>
        <!--end::title-->

        <div
          class="flex items-center justify-center flex-1 w-full p-4 mx-4 bg-white border border-gray-900 rounded-lg shadow-xl sm:mx-10 box sm:p-6"
        >
          <ul class="text-xl sm:text-3xl">
            <li>총 시 간 : {{ playTime | comma }} 초</li>
            <li>총 누른 수 : {{ total }} 번</li>
            <li>총 유효 누른 수 : {{ successCount }} 번</li>
            <li>총 무효 누른 수 : {{ nullityCount }} 번</li>
            <li>총 유효 확률 : {{ successPercent }} %</li>
            <li>총 무효 확률 : {{ nullityPercent }} %</li>
          </ul>
        </div>
        <!--end::content-->

        <div class="flex-none w-full p-4 sm:pb-10 sm:px-10">
          <JGButtonPrimary color="#4E9C16" class="w-full text-xl sm:text-3xl" @click.stop="retry">
            다시 연습해 볼래요!
          </JGButtonPrimary>

          <JGButtonPrimary
            v-if="GET_PLAY_MODE !== 'advanced'"
            color="#3A3534"
            class="w-full mt-4 text-xl sm:text-3xl sm:mt-10"
            @click.stop="changeMode(GET_PLAY_MODE === 'beginner' ? 'intermediate' : 'advanced')"
          >
            <span v-if="GET_PLAY_MODE === 'beginner'">중급편 연습하기</span>
            <span v-else>고급편 연습하기</span>
          </JGButtonPrimary>

          <JGButtonPrimary color="#D33011" class="w-full mt-4 text-xl sm:text-3xl sm:mt-10" @click="home">
            처음으로
          </JGButtonPrimary>
        </div>
        <!--end::footer-->
      </div>
    </modal>
  </BaseEventAware>
</template>

<script>
import * as _ from 'lodash'
import { ANSWER, MODE, PLAY_STATUS, PLAY_TIMER } from '@src/games/constant'
import { mapGetters } from 'vuex'
import { PLAYS } from '@state/modules/play'
import { EVENT_OBSERVERS } from '@state/modules/event-observer'
import JGButtonPrimary from '@src/games/jongrogu/components/jg-button-primary.vue'
import axios from 'axios'
import { AUTHS } from '@state/modules/auth'
import { GAMES } from '@state/modules/game'

export default {
  components: { JGButtonPrimary },
  data() {
    return {
      playTime: 0,
      score: 0,
      total: 0,
      successCount: 0,
      successPercent: 0,
      nullityCount: 0,
      nullityPercent: 0,
      failCount: 0,
      failPercent: 0,
    }
  },
  computed: {
    ...mapGetters(AUTHS.NAME, [AUTHS.GET_CURRENT_USER]),
    ...mapGetters(GAMES.NAME, [GAMES.GET_GAME_ID]),
    ...mapGetters(EVENT_OBSERVERS.NAME, [EVENT_OBSERVERS.GET_EVENT_CAPTURES]),
    ...mapGetters(PLAYS.NAME, [PLAYS.GET_PLAY, PLAYS.GET_PLAY_MODE, PLAYS.GET_START_TIME]),
    title() {
      return _.get(this.GET_PLAY, 'descriptions[0]')
    },
    modeText() {
      switch (this.GET_PLAY_MODE) {
        case MODE.BEGINNER:
          return '초급편'
        case MODE.INTERMEDIATE:
          return '중급편'
        case MODE.ADVANCED:
          return '고급편'
        default:
          this.$log.error('unexpected mode : ', this.GET_PLAY_MODE)
          return ''
      }
    },
  },
  methods: {
    home() {
      window.location.href = '/home'
    },
    mission() {
      window.location.href = '/games/' + _.toLower(this.GET_PLAY.name) + '/scenario'
    },
    retry() {
      window.location.reload()
    },
    changeMode(next) {
      const pathname = new URL(location.href).pathname
      window.location.href = pathname + '?mode=' + next
    },
    beforeOpen() {
      this.$events.emit(PLAY_TIMER.END)
      this.playTime = Math.floor((Date.now() - (this.GET_START_TIME || Date.now())) / 1000)

      // set the play status
      this.$store.commit(PLAYS.NAMESPACE(PLAYS.SET_PLAY_STATUS), PLAY_STATUS.COMPLETE)

      this.total = this.GET_EVENT_CAPTURES.length

      this.successCount = this.GET_EVENT_CAPTURES.filter((v) => v.type === ANSWER.EVENT_TYPE).length
      this.successPercent = Math.ceil((this.successCount * 100) / this.total)

      this.nullityCount = this.GET_EVENT_CAPTURES.filter((v) => v.type !== ANSWER.EVENT_TYPE).length
      this.nullityPercent = Math.ceil((this.nullityCount * 100) / this.total)

      this.failCount = this.GET_EVENT_CAPTURES.filter((v) => v.type !== ANSWER.EVENT_TYPE && v.inside).length
      this.failPercent = Math.ceil((this.failCount * 100) / this.total)

      // send to server for user result
      const params = new URLSearchParams()
      params.append('gameId', this.GET_GAME_ID)
      params.append('username', this.GET_CURRENT_USER.username)
      params.append('gender', this.GET_CURRENT_USER.gender)
      params.append('age', this.GET_CURRENT_USER.age)
      params.append('captureTotal', this.total)
      params.append('successCount', this.successCount)
      params.append('successPercent', this.successPercent)
      params.append('nullityCount', this.nullityCount)
      params.append('nullityPercent', this.nullityPercent)
      params.append('failCount', this.failCount)
      params.append('failPercent', this.failPercent)
      params.append('playTime', this.playTime)

      this.$log.debug('submit : ', params)

      axios
        .post('https://admin.kiosapp.kr/bbs/write_apply.php', params)
        .then(() => {
          /* ignore */
        })
        .catch(() => {
          /* ignore */
        })
    },
    beforeClose() {},
  },
}
</script>

<style lang="scss">
#missionSuccess {
  .vm--modal {
    overflow-y: scroll !important;
  }

  .vm--overlay {
    background: #fff1c1 !important;
  }
}
</style>
